import { render, staticRenderFns } from "./MessageAutoSent.vue?vue&type=template&id=6b436a3a&functional=true"
import script from "./MessageAutoSent.vue?vue&type=script&lang=js"
export * from "./MessageAutoSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports